import styled from 'styled-components';

import colors from 'themes/Main';

const { gray03, gray02 } = colors;

export const Container = styled.button`
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-top: 16px;
  background: transparent;
  border: 0;

  &:hover > p {
    color: ${gray02};
  }

  &:hover > div > svg path {
    fill: ${gray02};
  }
`;

export const Arrow = styled.div`
  svg path {
    fill: ${gray03};
    transition: fill 0.2s ease-in;
  }
`;

export const Text = styled.p`
  padding: 0;
  margin: 0 0 0 8px;
  font-size: 14px;
  font-weight: 700;
  text-transform: uppercase;
  color: ${gray03};
  transition: color 0.2s ease-in;
`;
